import { hotjar } from 'react-hotjar';

type LoggingArea = 'create-manual-payout' | 'dashboard';

type LoggingAction =
  | 'dialog-open'
  | 'dialog-close'
  | 'page-open'
  | 'form-submit';

type NewManualPayoutArea = 'new-manual-payout';
type NewManualPayoutAction =
  | 'intent'
  | 'submitted'
  | 'proceeded'
  | 'step_changed';

type LoggingId =
  | `${LoggingArea}:${LoggingAction}`
  | `${NewManualPayoutArea}:${NewManualPayoutAction}`;

export const logEventToHotjar = (eventName: LoggingId): void => {
  try {
    if (hotjar.initialized()) {
      hotjar.event(eventName);
    }
  } catch (loggingError) {
    // TODO: Improve handling/ignoring logging errors
    /* eslint-disable no-console */
    console.error('Error logging event to hotjar.', loggingError);
  }
};
